import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

import type { BlockCollapsePlugin } from './blockCollapsePluginType';
import { createPlugin } from './pm-plugins/main';
import { getBlockCollapseButtonComponents } from './ui/block-collapse-button-registration';

export const blockCollapsePlugin: BlockCollapsePlugin = ({ api }) => {
	const collapseButtonEnabled =
		isExperimentEnabled('platform_editor_block_control_migration') &&
		isExperimentEnabled('platform_editor_collapsible_headings');

	if (collapseButtonEnabled) {
		api?.uiControlRegistry?.actions.register(getBlockCollapseButtonComponents());
	}

	return {
		name: 'blockCollapse',
		pmPlugins() {
			return [
				{
					name: 'blockCollapsePlugin',
					plugin: createPlugin,
				},
			];
		},
	};
};
